// extracted by mini-css-extract-plugin
export default {"header":"header__xeZHdK","headerContainer":"headerContainer__rlGkFS","brand":"brand__oBKnpb","appName":"appName__aA3Qde","settings":"settings__KzLV2z"};